import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { WhyTDSPageRoutingModule } from './why-tds-routing.module';

import { WhyTDSPage } from './why-tds.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    WhyTDSPageRoutingModule
  ],
  declarations: [WhyTDSPage]
})
export class WhyTDSPageModule {}
